import Image from "next/image";
import { isStakingDeprecated } from "@/config";

export const DEXS = [
  {
    id: 1,
    name: "Gate",
    link: "https://www.gate.com/trade/SPON_USDT",
    logo: <Image height={24} width={24} src="/logos/gate.svg" alt="" className="w-6 h-6" />,
  },
  {
    id: 2,
    name: "MEXC",
    link: "https://www.mexc.com/exchange/SPON_USDT",
    logo: <Image height={24} width={24} src="/logos/mexc.svg" alt="" className="w-6 h-6" />,
  },
  {
    id: 3,
    name: "Lbank",
    link: "https://www.lbank.com/trade/spon_usdt",
    logo: <Image height={24} width={24} src="/logos/lbank.webp" alt="" className="w-6 h-6" />,
  },
  {
    id: 4,
    name: "Aerodrome",
    link: "https://aerodrome.finance/swap?from=eth&to=0x080d43c2164afdbc3712422ce78ab902ccab5ca1&chain0=8453&chain1=8453",
    logo: <Image height={24} width={24} src="/logos/aerodrome.svg" alt="" className="w-6 h-6" />,
  },
];

// While staking is deprecated we only point users to Aerodrome.
const ACTIVE_DEX_IDS_WHEN_DEPRECATED = [4];

export const getActiveDexes = () =>
  isStakingDeprecated
    ? DEXS.filter((dex) => ACTIVE_DEX_IDS_WHEN_DEPRECATED.includes(dex.id))
    : DEXS;
